if (!customElements.get('product-quantity-pricing-selector')) {
  const LIST_SCROLL_PADDING = 8;
  const setText = (node, value) => { if (node && node.textContent !== String(value)) node.textContent = value; };
  const setValue = (node, value) => { if (node && node.value !== String(value)) node.value = value; };
  const setAttribute = (node, name, value) => { if (node && node.getAttribute(name) !== value) node.setAttribute(name, value); };
  // Public scope only: reviewed legacy price recipes do not grant Studio or checkout admission.
  const LEGACY_XD_PRICING = Object.freeze({
    "15296153780610": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:9a2a65a2efeaba00",
      "variants": [
        "56485558944130",
        "56485558878594",
        "56485558911362"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": false
    },
    "15354307641730": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:c5147ffa87a319d9",
      "variants": [
        "56724865220994",
        "56724865253762",
        "56724865286530",
        "56724865319298",
        "56724865352066",
        "56724865384834",
        "56724865417602",
        "56724865483138",
        "56724865548674",
        "56724865581442",
        "56724865614210",
        "56806903775618"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15354314916226": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:ef595303d4e2b924",
      "variants": [
        "56724856406402",
        "56724856439170",
        "56724856471938",
        "56724856504706",
        "56724856537474"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15354316456322": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:6512ea392a4ee74a",
      "variants": [
        "56724855292290",
        "56724855325058",
        "56724855357826",
        "56724855390594",
        "56724855423362",
        "56724855456130",
        "56724855488898",
        "56724855521666",
        "56724855554434",
        "56724855587202",
        "56725286519170"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15354319274370": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:c3e094d7442882fa",
      "variants": [
        "56724797227394",
        "56724797358466",
        "56724800930178"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15354335822210": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:a96c5c16c0ce9fe7",
      "variants": [
        "56724822491522",
        "56724822524290",
        "56724829471106",
        "56724829503874",
        "56724829536642",
        "56724829569410",
        "56724829602178",
        "56724829634946",
        "56724829667714",
        "56726142321026"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15354341032322": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:e17079ecae282dc0",
      "variants": [
        "56724831371650",
        "56724831437186",
        "56724831469954",
        "56724831502722",
        "56724831404418",
        "56724837138818"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15354347258242": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:27aad3fc5c5f5ae8",
      "variants": [
        "56724839268738",
        "56724839334274",
        "56724849885570",
        "56724849918338",
        "56724849951106",
        "56724849983874",
        "56724850016642",
        "56724850049410",
        "56727139615106",
        "56727139647874",
        "56727139680642",
        "56730804945282"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15354519060866": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:f2bf4fd10cc3b787",
      "variants": [
        "56725304377730",
        "56725304443266",
        "56725304541570",
        "56725304476034",
        "56725304705410",
        "56725304508802",
        "56725304639874",
        "56725304672642"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15354841399682": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:a4e1207c88899410",
      "variants": [
        "56727133323650",
        "56727133356418",
        "56727133389186",
        "56727133421954",
        "56727133454722",
        "56727133487490"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15355272659330": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:5e34d83eaa160166",
      "variants": [
        "56729541706114",
        "56729541738882",
        "56729541771650",
        "56729541804418",
        "56729541837186"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15355276493186": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:a9554d2e953cbbe5",
      "variants": [
        "56729542394242",
        "56729542427010",
        "56729542459778",
        "56729542492546",
        "56729542525314"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15355278066050": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:809cd2495c07ae52",
      "variants": [
        "56729548456322",
        "56729548521858",
        "56729548587394"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15355491910018": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:c8d495c80fb5f910",
      "variants": [
        "56730650870146",
        "56730650902914",
        "56730650935682"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    },
    "15368238956930": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:dd6054084e800685",
      "variants": [
        "56772807950722",
        "56772807983490",
        "56772808016258",
        "56772808049026"
      ],
      "minimum": 15,
      "maximum": 2000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000,
        2000
      ],
      "sizes": false
    },
    "15405763068290": {
      "revision": "xd-legacy-recipes-a25897c4bfd26bfe5423c1fa:9ef101974d0c5282",
      "variants": [
        "56945522246018",
        "56945527488898",
        "56945527521666",
        "56945527554434",
        "56945527587202",
        "56945527619970",
        "56945527652738",
        "56945527685506",
        "56945527718274",
        "56945527751042",
        "56945527783810",
        "56945527816578",
        "56945527849346",
        "56945527882114",
        "56945527914882",
        "56945527947650",
        "56945527980418",
        "56945528013186",
        "56945528045954",
        "56945528078722",
        "56945528111490",
        "56945528144258",
        "56945528177026",
        "56945528209794",
        "56945528242562",
        "56945528275330",
        "56945528308098",
        "56945528340866",
        "56945528373634",
        "56945528406402",
        "56945528439170",
        "56945528471938",
        "56945528504706",
        "56945528537474"
      ],
      "minimum": 15,
      "maximum": 1000,
      "quantities": [
        15,
        25,
        50,
        100,
        250,
        500,
        1000
      ],
      "sizes": true
    }
  });



  function configuredXDFresh(value) {
    return Number.isFinite(Date.parse(value)) && Date.parse(value) > Date.now();
  }

  function configuredXDRevision(value) {
    return typeof value === 'string' && /^[A-Za-z0-9][A-Za-z0-9_.:-]{0,199}$/.test(value);
  }

  function earliestConfiguredXDValidUntil(...values) {
    const times = values.filter(Boolean).map(value => Date.parse(value));
    if (!times.length || times.some(value => !Number.isFinite(value) || value <= Date.now())) return null;
    return new Date(Math.min(...times)).toISOString();
  }

  function embeddedNeutralDisplay(source, variantId) {
    const rows = source?.initialDisplay?.neutralPrices;
    return Array.isArray(rows) ? rows.find(item => String(item?.variantId || '') === variantId) || null : null;
  }

  function quoteAmounts(quote, quantity) {
    const unit = quote?.unitPriceCents, items = unit * quantity;
    if (!Number.isSafeInteger(quantity) || quantity < 1 || !Number.isSafeInteger(unit) || unit <= 0 || !Number.isSafeInteger(items)) return null;
    if (quote.feeMode == null || quote.feeMode === '') return quote.totalPriceCents === items ? { itemsTotalPriceCents: items, totalPriceCents: items } : null;
    if (quote.feeMode !== 'separate' || quote.itemsTotalPriceCents !== items
      || ![quote.technicalFeesCents, quote.preparationFeesCents].every(value => Number.isSafeInteger(value) && value >= 0)) return null;
    if (quote.preparationUnitPriceMicro !== undefined && (typeof quote.preparationUnitPriceMicro !== 'string'
      || !/^(0|[1-9]\d{0,24})$/.test(quote.preparationUnitPriceMicro)
      || (BigInt(quote.preparationUnitPriceMicro) * BigInt(quantity) + 9999n) / 10000n !== BigInt(quote.preparationFeesCents))) return null;
    const total = items + quote.technicalFeesCents + quote.preparationFeesCents;
    return Number.isSafeInteger(total) && quote.totalPriceCents === total ? { feeMode: 'separate', itemsTotalPriceCents: items,
      technicalFeesCents: quote.technicalFeesCents, preparationFeesCents: quote.preparationFeesCents, totalPriceCents: total,
      ...(quote.preparationUnitPriceMicro !== undefined ? { preparationUnitPriceMicro: quote.preparationUnitPriceMicro } : {}) } : null;
  }


  class ProductQuantityPricingSelector extends HTMLElement {
    connectedCallback() {
      this.cleanup();

      this.helper = window.TodayMerchQuantityPricing;
      this.prefersReducedMotion = Boolean(window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
      this.staticOpen = this.dataset.staticOpen === 'true';
      this.compactGrid = this.dataset.compactGrid === 'true';
      this.quoteTiers = this.dataset.quoteTiers === 'true';
      this.selectionMode = undefined;
      this.data = this.parseData();

      if (!this.hasValidData(this.data)) return;

      this.data.tiers = this.normalizeTiers(this.data.tiers);
      if (!this.data.tiers.length) return;

      this.abortController = new AbortController();
      this.sourceInputAbortController = new AbortController();
      this.isSyncingSourceInput = false;
      this.bound = this.createBoundHandlers();

      this.cacheElements();
      this.legacyXDRoot = this.closest('product-info');
      this.legacyXDProductId = String(this.legacyXDRoot?.dataset?.productId || '');
      this.legacyXDScope = LEGACY_XD_PRICING[this.legacyXDProductId];
      this.legacyXDPricingEnabled = Boolean(this.legacyXDScope);
      if (this.legacyXDPricingEnabled) this.supplierPricing = { status: 'pending', grid: [], estimated: true };
      this.initializeDrawer();
      this.reorderTierButtons();
      this.bindEvents();
      this.bindSourceInput();
      this.syncFromSourceInput();
      this.applyConfiguredXDInitialPricing();
      this.subscribeToQuantityUpdates();
      this.subscribeToVariantChanges();
      if (this.configuredXDConfig) this.activateConfiguredXDPricing(this.configuredXDConfig);
      if (this.legacyXDPricingEnabled) {
        const refresh = () => this.refreshLegacyXDPricing();
        for (const name of ['quantity-pricing:change', 'todaymerch:variant-media-updated', 'change', 'input']) {
          this.legacyXDRoot.addEventListener(name, refresh, { signal: this.abortController.signal });
        }
        this.loadLegacyXDPricing();
      }
      this.personalizationLegacyPricingEnabled = Boolean(this.data.personalizationPricing && !this.isPersonalizationV2Active());
      if (this.personalizationLegacyPricingEnabled) {
        this.setSupplierPricing({ provider: 'personalization', status: 'pending', grid: [] });
        const initialize = () => {
          if (!this.personalizationPricingController && window.TodayMerchPersonalizationPricing) {
            this.personalizationPricingController = window.TodayMerchPersonalizationPricing.create(this);
          }
        };
        window.addEventListener('todaymerch:personalization-pricing-ready', initialize, { signal: this.abortController.signal });
        initialize();
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cleanup() {
      this.legacyXDRequest?.abort();
      this.legacyXDRequest = null;
      this.legacyXDProjection = null;
      clearTimeout(this.legacyXDTimer);
      if (this.legacyXDRoot?.todayMerchLegacyXDPricing === this) {
        delete this.legacyXDRoot.todayMerchLegacyXDPricing;
        delete this.legacyXDRoot.dataset.legacyXdPublicPricing;
      }
      if (this.legacyXDPricingEnabled) this.supplierPricing = null;
      this.legacyXDPricingEnabled = false;
      this.legacyXDNote?.remove();
      this.legacyXDNote = null;
      this.personalizationPricingController?.destroy();
      this.personalizationPricingController = undefined;
      this.personalizationLegacyPricingEnabled = false;
      this.abortController?.abort();
      this.abortController = undefined;

      this.sourceInputAbortController?.abort();
      this.sourceInputAbortController = undefined;

      this.drawer?.destroy();
      this.drawer = undefined;

      if (typeof this.quantityUpdateUnsubscriber === 'function') {
        this.quantityUpdateUnsubscriber();
      }

      if (typeof this.variantChangeUnsubscriber === 'function') {
        this.variantChangeUnsubscriber();
      }

      this.quantityUpdateUnsubscriber = undefined;
      this.variantChangeUnsubscriber = undefined;
      this.bound = undefined;
      this.isSyncingSourceInput = false;
    }

    isPersonalizationV2Active() {
      const root = this.legacyXDRoot || this.closest('product-info');
      if (!root) return false;
      if (root.dataset.personalizationV2Active === 'true' || root.dataset.personalizationStreamlinedActive === 'true') return true;
      const choice = root.querySelector('product-personalization-choice[data-personalization-v2]');
      if (!choice) return false;
      const script = choice.querySelector('[data-personalization-v2-config]');
      if (!script) return true;
      try {
        const config = JSON.parse(script.textContent || '{}');
        return config?.enabled === true && config.schemaVersion === 2 && Array.isArray(config.variants);
      } catch {
        return false;
      }
    }

    validateLegacyXDPricing(value) {
      const scope = this.legacyXDScope, now = Date.now();
      const same = (left, right) => Array.isArray(left) && left.length === right.length
        && new Set(left).size === left.length && left.every(item => right.includes(item));
      const expiry = Date.parse(value?.validUntil), generated = Date.parse(value?.generatedAt);
      if (!scope || value?.enabled !== true || value.schemaVersion !== 1 || value.provider !== 'xd' || value.mode !== 'legacy'
        || value.productId !== this.legacyXDProductId || value.configurationRevision !== scope.revision
        || !/^[a-f0-9]{64}$/.test(value.priceRevision || '') || value.feeMode !== 'separate' || value.policyVersion !== '1.4'
        || value.checkoutEnabled !== false || value.productionReady !== false || value.stockReserved !== false
        || value.requiresSizeAllocation !== scope.sizes || value.minimumQuantity !== scope.minimum || value.maximumQuantity !== scope.maximum
        || !same(value.publicQuantities, scope.quantities) || !same(value.variants?.map(variant => variant.variantId), scope.variants)
        || value.standardMarking?.colors !== 1 || value.standardMarking?.positions !== 1
        || !Number.isFinite(generated) || generated > now + 60000 || !Number.isFinite(expiry) || expiry <= now
        || expiry <= generated || expiry - generated > 1800000
        || ![value.priceValidUntil, value.stockValidUntil].every(date => Number.isFinite(Date.parse(date)) && Date.parse(date) >= expiry)) return null;
      for (const variant of value.variants) {
        if (variant.requiresSizeAllocation !== scope.sizes || !Number.isSafeInteger(variant.minimumQuantity)
          || variant.minimumQuantity < scope.minimum || variant.minimumQuantity > scope.maximum || variant.maximumQuantity !== scope.maximum
          || !Array.isArray(variant.tiers) || !['priced', 'quote_required'].includes(variant.status)) return null;
        if (variant.status === 'quote_required') { if (variant.tiers.length) return null; continue; }
        if (!variant.tiers.length || variant.tiers.length > 128 || variant.tiers[0].quantity !== variant.minimumQuantity) return null;
        for (const [index, tier] of variant.tiers.entries()) {
          if (!Number.isSafeInteger(tier.quantity) || tier.feeMode !== 'separate' || !quoteAmounts(tier, tier.quantity)
            || tier.maximumQuantityExclusive !== (variant.tiers[index + 1]?.quantity ?? scope.maximum + 1)
            || tier.maximumQuantityExclusive <= tier.quantity || tier.quantity > scope.maximum) return null;
        }
      }
      return value;
    }

    activateConfiguredXDPricing(config) {
      const contract = config?.configuredPricing, deferred = config?.deferredPricing;
      const requiresSizeAllocation = config?.requiresSizeAllocation === true;
      if (config?.enabled !== true || config.schemaVersion !== 2 || String(config.productId) !== this.legacyXDProductId
        || config.checkoutEnabled !== false || !configuredXDRevision(config.configurationRevision)
        || contract?.schemaVersion !== 1 || contract.mode !== 'artwork_v2' || contract.commercialPolicy !== 'legacy_visible_v1.4'
        || !Array.isArray(config.variants) || !config.variants.length
        || requiresSizeAllocation && (deferred?.schemaVersion !== 1 || deferred.mode !== 'size_group'
          || deferred.allocationSupported !== true || deferred.commercialPolicy !== contract.commercialPolicy)) return false;
      const sameRevision = this.configuredXDPricing?.configurationRevision === config.configurationRevision && !this.legacyXDPricingEnabled;
      if (this.configuredXDConfig === config && sameRevision) return true;
      // Retire the legacy request before any render/event can observe this switch.
      // A response already resolving cannot restore its one-colour prices.
      this.legacyXDRequest?.abort();
      this.legacyXDRequest = null;
      clearTimeout(this.legacyXDTimer);
      this.legacyXDProjection = null;
      this.legacyXDPricingEnabled = false;
      this.configuredXDConfig = config;
      this.configuredXDPricing = { configurationRevision: config.configurationRevision, requiresSizeAllocation,
        configuredPricing: { ...contract }, ...(requiresSizeAllocation ? { deferredPricing: { ...deferred } } : {}) };
      if (this.legacyXDRoot?.todayMerchLegacyXDPricing === this) delete this.legacyXDRoot.todayMerchLegacyXDPricing;
      if (this.legacyXDRoot) delete this.legacyXDRoot.dataset.legacyXdPublicPricing;
      this.legacyXDNote?.remove();
      this.legacyXDNote = null;
      this.refreshFormBindings();
      for (const key of ['_xd_legacy_price_only', '_xd_legacy_configuration_revision', '_xd_legacy_variant_id', '_xd_requires_size_allocation']) {
        this.form?.querySelector(`[data-supplier-property="${key}"]`)?.remove();
      }
      const currentVariantId = String(this.form?.querySelector('input[name="id"]')?.value || '');
      const keepInitial = sameRevision && this.supplierPricing?.estimated === true && this.supplierPricing?.status === 'priced'
        && this.supplierPricing.variantId === currentVariantId && Date.parse(this.supplierPricing.validUntil) > Date.now();
      if (!keepInitial) this.setSupplierPricing({ status: 'pending', grid: [] });
      this.dispatchEvent(new CustomEvent('todaymerch:configured-xd-pricing-change', { bubbles: true }));
      return true;
    }

    applyConfiguredXDInitialPricing() {
      const source = this.data?.configuredXDInitialPricing;
      if (!source || this.legacyXDPricingEnabled || this.personalizationLegacyPricingEnabled) return false;
      this.refreshFormBindings();
      const productId = String(this.legacyXDRoot?.dataset?.productId || ''), displayRoot = source.initialDisplay || {};
      const variantId = String(this.form?.querySelector('input[name="id"]')?.value || '');
      const quantity = Number(this.sourceInput?.value || this.data.defaultQuantity);
      const display = embeddedNeutralDisplay(source, variantId);
      const tier = display?.tiers?.find(item => item.quantity === quantity);
      const validUntil = earliestConfiguredXDValidUntil(source.validUntil, displayRoot.validUntil, display?.validUntil, tier?.validUntil || display?.validUntil);
      if (!productId || !variantId || !Number.isSafeInteger(quantity) || quantity < this.data.min
        || source.kind !== 'today_pricing_projection_snapshot_v1' || source.schemaVersion !== 1
        || !['xd', 'midocean', 'pfconcept'].includes(source.supplier) || String(source.productId || displayRoot.productId || '') !== productId
        || displayRoot.checkoutEnabled !== false || displayRoot.stockReserved !== false
        || !configuredXDRevision(displayRoot.configurationRevision) || !configuredXDRevision(source.identity?.pricingRevision || displayRoot.pricingRevision)
        || !display || display.pricingPurpose !== 'display_only' && display.pricingPurpose !== 'initial_display'
        || !tier || !validUntil || tier.estimated !== false && tier.estimated !== true) return false;
      const quote = { status: 'priced', estimated: true, quantity, currency: tier.currency || 'EUR', checkoutEnabled: false, stockReserved: false,
        unitPriceCents: tier.unitPriceCents, itemsTotalPriceCents: tier.unitPriceCents * quantity,
        technicalFeesCents: 0, preparationFeesCents: 0, totalPriceCents: tier.totalPriceCents,
        feeMode: tier.feeMode || displayRoot.feeMode, variantId, configurationRevision: displayRoot.configurationRevision,
        availability: display.availability };
      if (quote.feeMode !== 'separate') {
        delete quote.itemsTotalPriceCents; delete quote.technicalFeesCents; delete quote.preparationFeesCents;
      }
      if (!quoteAmounts(quote, quantity)) return false;
      const grid = (Array.isArray(display.tiers) ? display.tiers : [])
        .filter(entry => Number.isSafeInteger(entry.quantity) && entry.quantity >= this.data.min
          && Number.isSafeInteger(entry.unitPriceCents) && entry.unitPriceCents > 0 && configuredXDFresh(entry.validUntil || display.validUntil))
        .map(entry => ({ quantity: entry.quantity, status: 'priced', unitPriceCents: entry.unitPriceCents }));
      if (!grid.some(entry => entry.quantity === quantity && entry.unitPriceCents === quote.unitPriceCents)) {
        grid.push({ quantity, status: 'priced', unitPriceCents: quote.unitPriceCents });
      }
      if (source.supplier === 'xd') {
        if (source.configurationTransport === undefined && !displayRoot.configurationRevision) return false;
        this.configuredXDConfig = { enabled: true, schemaVersion: 2, provider: 'xd', productId, checkoutEnabled: false,
          configurationRevision: displayRoot.configurationRevision,
          configuredPricing: { schemaVersion: 1, mode: 'artwork_v2', commercialPolicy: 'legacy_visible_v1.4' }, variants: [{ variantId }] };
        this.configuredXDPricing = { configurationRevision: displayRoot.configurationRevision, requiresSizeAllocation: false,
          configuredPricing: { ...this.configuredXDConfig.configuredPricing } };
      }
      this.setSupplierPricing({ provider: 'embedded-display', supplier: source.supplier, status: 'priced', estimated: true, quote, grid,
        variantId, configurationRevision: displayRoot.configurationRevision, validUntil,
        revision: source.identity?.pricingRevision || displayRoot.pricingRevision, availability: display.availability });
      this.dataset.configuredXdInitialPricing = 'true';
      this.dataset.supplierInitialPricing = source.supplier;
      return true;
    }

    getEmbeddedInitialPricing() {
      this.refreshFormBindings();
      const quantity = Number(this.sourceInput?.value || this.data?.defaultQuantity);
      const state = this.getSupplierPricingState(quantity);
      if (this.dataset.configuredXdInitialPricing !== 'true' || state?.supplierStatus !== 'priced'
        || this.supplierPricing?.estimated !== true || this.supplierPricing?.provider !== 'embedded-display') return null;
      const variantId = String(this.form?.querySelector('input[name="id"]')?.value || '');
      const gridTier = (Array.isArray(this.supplierPricing.grid) ? this.supplierPricing.grid : [])
        .find(entry => entry.quantity === quantity && entry.status === 'priced');
      if (!variantId || this.supplierPricing.variantId !== variantId || this.supplierPricing.quote?.quantity !== quantity
        || (this.configuredXDPricing && this.supplierPricing.configurationRevision !== this.configuredXDPricing.configurationRevision)
        || Date.parse(this.supplierPricing.validUntil) <= Date.now()
        || !gridTier || gridTier.unitPriceCents !== this.supplierPricing.quote.unitPriceCents
        || !quoteAmounts(this.supplierPricing.quote, quantity)) return null;
      return { productId: this.legacyXDProductId, supplier: this.supplierPricing.supplier, variantId, quantity, status: 'priced', estimated: true,
        configurationRevision: this.supplierPricing.configurationRevision, priceRevision: this.supplierPricing.revision,
        validUntil: this.supplierPricing.validUntil, quote: this.supplierPricing.quote, grid: this.supplierPricing.grid || [] };
    }

    getConfiguredXDPricingContext() {
      const config = this.configuredXDConfig;
      if (!config || this.legacyXDPricingEnabled) return null;
      this.refreshFormBindings();
      const variantId = String(this.form?.querySelector('input[name="id"]')?.value || '');
      const variant = config.variants.find(item => String(item.variantId) === variantId);
      if (!variant) return null;
      if (config.requiresSizeAllocation === true && (!Array.isArray(variant.sizeOptions) || !variant.sizeOptions.length
        || variant.sizeOptions.some(value => typeof value !== 'string' || !value.trim() || value.length > 64)
        || new Set(variant.sizeOptions).size !== variant.sizeOptions.length)) return null;
      return { ...this.configuredXDPricing, productId: this.legacyXDProductId, variantId,
        sizeOptions: Array.isArray(variant.sizeOptions) ? [...variant.sizeOptions] : [] };
    }

    async loadLegacyXDPricing() {
      if (!this.legacyXDPricingEnabled || !this.isConnected || this.legacyXDRequest || !this.legacyXDScope) return;
      clearTimeout(this.legacyXDTimer);
      const request = new AbortController();
      this.legacyXDRequest = request;
      this.refreshLegacyXDPricing();
      const timeout = setTimeout(() => request.abort(), 15000);
      let validUntil = null;
      try {
        const url = `/apps/todays-studio/xd/pricing?productId=${this.legacyXDProductId}&configurationRevision=${encodeURIComponent(this.legacyXDScope.revision)}`;
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: request.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('pricing_unavailable');
        const projection = this.validateLegacyXDPricing(await response.json());
        if (!projection) throw new Error('pricing_identity_invalid');
        if (this.legacyXDRequest !== request || !this.isConnected) return;
        this.legacyXDProjection = projection;
        this.legacyXDRoot.todayMerchLegacyXDPricing = this;
        this.legacyXDRoot.dataset.legacyXdPublicPricing = 'true';
        validUntil = projection.validUntil;
      } catch (_) {
        if (this.legacyXDRequest === request) this.legacyXDProjection = null;
      } finally {
        clearTimeout(timeout);
        if (this.legacyXDRequest === request) {
          this.legacyXDRequest = null;
          if (this.isConnected) {
            this.refreshLegacyXDPricing();
            this.legacyXDTimer = setTimeout(() => this.loadLegacyXDPricing(), validUntil ? Math.max(1, Date.parse(validUntil) - Date.now()) : 60000);
          }
        }
      }
    }

    legacyXDQuote(quantity, variantId) {
      const source = this.legacyXDProjection;
      if (!source || Date.parse(source.validUntil) <= Date.now() || !Number.isSafeInteger(quantity)) return null;
      const variant = source.variants.find(item => item.variantId === variantId);
      if (variant?.status !== 'priced' || quantity < variant.minimumQuantity || quantity > variant.maximumQuantity) return null;
      const tier = variant.tiers.find(item => item.quantity <= quantity && quantity < item.maximumQuantityExclusive);
      if (!tier) return null;
      const itemsTotalPriceCents = tier.unitPriceCents * quantity;
      const quote = { ...tier, quantity, itemsTotalPriceCents, totalPriceCents: itemsTotalPriceCents + tier.technicalFeesCents + tier.preparationFeesCents,
        variantId, configurationRevision: source.configurationRevision, status: 'priced', currency: 'EUR', checkoutEnabled: false, estimated: true };
      return quoteAmounts(quote, quantity) ? quote : null;
    }

    refreshLegacyXDPricing() {
      if (!this.legacyXDPricingEnabled || this.refreshingLegacyXD || !this.isConnected) return;
      this.refreshingLegacyXD = true;
      try {
        this.refreshFormBindings();
        const variantId = String(this.form?.querySelector('input[name="id"]')?.value || '');
        const quantity = Number(this.compactGrid && this.selectionMode === 'custom' ? this.customInput?.value : this.sourceInput?.value);
        const quote = this.legacyXDQuote(quantity, variantId), projection = this.legacyXDProjection;
        const grid = projection?.publicQuantities.map(value => this.legacyXDQuote(value, variantId)).filter(Boolean) || [];
        this.setSupplierPricing({ legacyPriceOnly: true, status: quote ? 'priced' : this.legacyXDRequest ? 'pending' : 'quote_required',
          estimated: true, quote, grid, validUntil: projection?.validUntil, revision: projection?.priceRevision });
        if (!this.legacyXDNote) {
          this.legacyXDNote = document.createElement('p'); this.legacyXDNote.className = 'quantity-pricing-selector__pricing-note';
          this.legacyXDNote.dataset.legacyXdPricingNote = ''; this.append(this.legacyXDNote);
        }
        this.legacyXDNote.textContent = quote && (quote.technicalFeesCents || quote.preparationFeesCents) ? 'Frais techniques et préparation inclus dans le total' : '';
        this.legacyXDNote.hidden = !this.legacyXDNote.textContent;
      } finally { this.refreshingLegacyXD = false; }
    }

    getLegacyXDPricingContext() {
      if (this.legacyXDRoot?.todayMerchLegacyXDPricing !== this || !this.legacyXDScope) return null;
      const variantId = String(this.form?.querySelector('input[name="id"]')?.value || '');
      const quantity = Number(this.sourceInput?.value);
      if (!this.legacyXDScope.variants.includes(variantId) || !Number.isSafeInteger(quantity) || quantity < this.legacyXDScope.minimum) return null;
      return { productId: this.legacyXDProductId, variantId, quantity, requiresSizeAllocation: this.legacyXDScope.sizes,
        configurationRevision: this.legacyXDScope.revision, checkoutEnabled: false,
        quote: this.legacyXDQuote(quantity, variantId), priceRevision: this.legacyXDProjection?.priceRevision,
        validUntil: this.legacyXDProjection?.validUntil };
    }

    createBoundHandlers() {
      return {
        onTierListClick: this.handleTierListClick.bind(this),
        onCustomInput: this.handleCustomInput.bind(this),
        onCustomInputFocus: this.handleCustomInputFocus.bind(this),
        onCustomCellClick: this.handleCustomCellClick.bind(this),
        onCustomInputCommit: this.handleCustomInputCommit.bind(this),
        onCustomInputKeydown: this.handleCustomInputKeydown.bind(this),
        onSourceInputSync: this.syncFromSourceInput.bind(this),
        onQuantityUpdate: this.handleQuantityUpdate.bind(this),
        onVariantChange: this.handleVariantChange.bind(this),
        onFormSubmit: this.handleFormSubmit.bind(this),
      };
    }

    parseData() {
      const node = this.querySelector('[data-quantity-pricing-data]');
      if (!node) return null;

      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    hasValidData(data) {
      return Boolean(data && Array.isArray(data.tiers) && data.tiers.length);
    }

    normalizeTiers(tiers) {
      if (this.helper?.normalizeTiers) return this.helper.normalizeTiers(tiers);

      return tiers
        .map((tier) => ({
          qty: Number(tier.qty || 0),
          unit_price_cents: Number(tier.unit_price_cents || 0),
        }))
        .filter((tier) => Number.isFinite(tier.qty) && tier.qty > 0 && Number.isFinite(tier.unit_price_cents) && tier.unit_price_cents > 0)
        .sort((a, b) => a.qty - b.qty);
    }

    cacheElements() {
      this.trigger = this.querySelector('[data-role="trigger"]');
      this.panel = this.querySelector('[data-role="panel"]');
      this.tierList = this.querySelector('[data-role="tier-list"]');
      this.customInput = this.querySelector('[data-role="custom-quantity-input"]');
      this.customCell = this.querySelector('[data-role="custom-quantity-cell"]');
      this.customUnitPrice = this.querySelector('[data-role="custom-unit-price"]');
      this.summaryQty = this.querySelector('[data-role="summary-qty"]');
      this.summaryUnitPrice = this.querySelector('[data-role="summary-unit-price"]');
      this.summarySavings = this.querySelector('[data-role="summary-savings"]');
      this.summaryTotal = this.querySelector('[data-role="summary-total"]');
      this.tierButtons = Array.from(this.querySelectorAll('[data-role="tier"]'));
      this.refreshFormBindings();
    }

    initializeDrawer() {
      if (!this.trigger || !this.panel) return;

      this.drawer?.destroy();
      this.drawer = window.TodayMerchProductOptionDrawer?.create({
        host: this,
        trigger: this.trigger,
        panel: this.panel,
        prefersReducedMotion: this.prefersReducedMotion,
        staticOpen: this.staticOpen,
        onOpen: () => this.scrollActiveTierIntoView(),
      });

      this.drawer?.init({ startsOpen: this.staticOpen });
    }

    refreshFormBindings() {
      const form = document.getElementById(this.data?.productFormId);
      const previousInput = this.sourceInput;
      this.form = form || null;
      this.sourceInput = form?.querySelector('input[name="quantity"]') || null;
      const retained = this.closest('product-info')?.todayMerchQuantitySelection;
      if (this.sourceInput && this.sourceInput !== previousInput && retained?.productFormId === this.data?.productFormId) {
        // A variant section can replace the form with its default quantity.
        // Keep the visitor's explicit choice, subject to the new variant rules.
        this.sourceInput.value = String(this.normalizeQuantity(retained.quantity));
        this.selectionMode = retained.selectionMode;
      }
      const fields = { appliedTierQty: 'applied-tier-qty', appliedUnitPriceCents: 'applied-unit-price-cents',
        appliedDiscountPct: 'applied-discount-pct', pricingMode: 'pricing-mode', profile: 'profile', tiers: 'tiers', currency: 'currency', native: 'native' };
      const previous = this.properties || {};
      this.properties = Object.fromEntries(Object.entries(fields).map(([key, role]) => [key,
        previous[key]?.isConnected && form?.contains(previous[key]) ? previous[key]
          : form?.querySelector(`[data-quantity-pricing-property="${role}"]`) || null]));
    }

    reorderTierButtons() {
      if (!this.tierList || !this.tierButtons?.length) return;

      this.tierButtons = this.tierButtons
        .slice()
        .sort((buttonA, buttonB) => {
          const qtyA = Number.parseInt(buttonA.dataset.tierQty, 10) || 0;
          const qtyB = Number.parseInt(buttonB.dataset.tierQty, 10) || 0;
          if (qtyA !== qtyB) return qtyA - qtyB;

          const priceA = Number.parseInt(buttonA.dataset.tierUnitPriceCents, 10) || 0;
          const priceB = Number.parseInt(buttonB.dataset.tierUnitPriceCents, 10) || 0;
          return priceA - priceB;
        });

      this.tierButtons.forEach((button) => this.tierList.appendChild(button));
      if (this.compactGrid && this.customCell) this.tierList.appendChild(this.customCell);
    }

    bindEvents() {
      if (!this.abortController || !this.bound) return;

      const { signal } = this.abortController;

      this.tierList?.addEventListener('click', this.bound.onTierListClick, { signal });
      this.customInput?.addEventListener('input', this.bound.onCustomInput, { signal });
      this.customInput?.addEventListener('change', this.bound.onCustomInputCommit, { signal });
      this.customInput?.addEventListener('blur', this.bound.onCustomInputCommit, { signal });
      this.customInput?.addEventListener('keydown', this.bound.onCustomInputKeydown, { signal });
      if (this.compactGrid) {
        this.customInput?.addEventListener('focus', this.bound.onCustomInputFocus, { signal });
        this.customCell?.addEventListener('click', this.bound.onCustomCellClick, { signal });
      }
    }

    bindSourceInput() {
      this.refreshFormBindings();

      this.sourceInputAbortController?.abort();
      this.sourceInputAbortController = new AbortController();

      if (!this.sourceInput || !this.bound) return;

      const { signal } = this.sourceInputAbortController;
      this.sourceInput.addEventListener('input', this.bound.onSourceInputSync, { signal });
      this.sourceInput.addEventListener('change', this.bound.onSourceInputSync, { signal });
      this.form?.addEventListener('submit', this.bound.onFormSubmit, { signal, capture: this.compactGrid });
    }

    subscribeToQuantityUpdates() {
      if (!FoxTheme?.pubsub?.subscribe || !this.bound) return;

      this.quantityUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate,
        this.bound.onQuantityUpdate
      );
    }

    subscribeToVariantChanges() {
      if (!FoxTheme?.pubsub?.subscribe || !this.bound) return;

      this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
        this.bound.onVariantChange
      );
    }

    handleTierListClick(event) {
      const button = event.target.closest('[data-role="tier"]');
      if (!button || !this.tierList?.contains(button)) return;

      const quantity = Number.parseInt(button.dataset.tierQty, 10);
      if (!Number.isFinite(quantity)) return;

      this.applyQuantity(quantity, { close: !this.staticOpen, syncOnly: false, selectionMode: 'tier' });
      if (!this.staticOpen) this.drawer?.focusTrigger();
    }

    handleCustomInput(event) {
      if (this.compactGrid) {
        this.selectionMode = 'custom';
        const rawQuantity = String(event.target.value).trim();
        const quantity = Number(rawQuantity);
        const validQuantity = /^\d+$/.test(rawQuantity) && Number.isSafeInteger(quantity) && quantity > 0;
        if (!validQuantity || this.normalizeQuantity(quantity) !== quantity) {
          this.renderState(this.state, { preserveCustomInput: true });
          return;
        }
        this.applyQuantity(quantity, { selectionMode: 'custom', preserveCustomInput: true, sourceEvent: event });
        return;
      }

      const parsedQuantity = Number.parseInt(event.target.value, 10);
      if (!Number.isFinite(parsedQuantity) || parsedQuantity <= 0) return;
      this.renderState(this.computeState(parsedQuantity));
    }

    handleCustomInputCommit(event) {
      if (this.compactGrid && this.selectionMode !== 'custom') return;
      this.applyQuantity(this.customInput?.value, { close: false, syncOnly: false, selectionMode: 'custom', sourceEvent: event });
    }

    handleCustomInputFocus() {
      if (!this.compactGrid) return;
      this.selectionMode = 'custom';
      this.renderState(this.state, { preserveCustomInput: true });
    }

    handleCustomCellClick() {
      if (!this.compactGrid) return;
      this.customInput?.focus();
    }

    handleCustomInputKeydown(event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      event.todayMerchQuantityCommit = true;
      this.handleCustomInputCommit(event);
    }

    handleQuantityUpdate() {
      if (this.isSyncingSourceInput) return;
      this.bindSourceInput();
      const retained = this.closest('product-info')?.todayMerchQuantitySelection;
      const previousQuantity = this.state?.quantity;
      if (this.sourceInput && retained?.productFormId === this.data?.productFormId) {
        // Native quantity boundaries reset this same input to its minimum after
        // a variant refresh. Restore the visitor's choice under the new rules.
        retained.quantity = this.normalizeQuantity(retained.quantity);
        this.sourceInput.value = String(retained.quantity);
      }
      this.syncFromSourceInput();
      if (retained && this.state?.quantity !== previousQuantity) {
        this.dispatchEvent(new CustomEvent('quantity-pricing:change', { bubbles: true, detail: this.state }));
      }
    }

    handleVariantChange(event) {
      const sectionId = event?.data?.sectionId;
      if (!sectionId || this.data?.productFormId !== `product-form-${sectionId}`) return;

      this.bindSourceInput();
      this.syncFromSourceInput();
    }

    handleFormSubmit(event) {
      if (this.personalizationLegacyPricingEnabled && !this.personalizationPricingController) {
        event?.preventDefault();
        event?.stopImmediatePropagation();
        return;
      }
      if (this.compactGrid) {
        if (this.selectionMode === 'custom') this.handleCustomInputCommit();
        else this.syncFromSourceInput();
      }
      const quantity = this.normalizeQuantity(this.sourceInput?.value || this.state?.quantity || this.data.defaultQuantity || this.data.min);
      const state = this.computeState(quantity);
      if (!state) return;
      this.syncPropertyInputs(state);
    }

    isOpen() {
      return this.drawer?.isOpen() || false;
    }

    scrollActiveTierIntoView() {
      if (!this.tierList || !this.tierButtons?.length) return;

      const activeTier = this.tierButtons.find((button) => button.classList.contains('is-active'));
      if (!activeTier) return;

      const tierTop = activeTier.offsetTop;
      const tierBottom = tierTop + activeTier.offsetHeight;
      const viewTop = this.tierList.scrollTop;
      const viewBottom = viewTop + this.tierList.clientHeight;

      let targetScrollTop = null;

      if (tierTop - LIST_SCROLL_PADDING < viewTop) {
        targetScrollTop = Math.max(tierTop - LIST_SCROLL_PADDING, 0);
      } else if (tierBottom + LIST_SCROLL_PADDING > viewBottom) {
        targetScrollTop = Math.max(tierTop - LIST_SCROLL_PADDING, 0);
      }

      if (targetScrollTop == null) return;

      this.tierList.scrollTo({
        top: targetScrollTop,
        behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
      });
    }

    getRules() {
      if (this.helper?.getRulesFromAttributes) {
        return this.helper.getRulesFromAttributes(this.sourceInput, {
          min: this.data.min,
          increment: this.data.step,
          max: this.data.max,
        });
      }

      const min = Number(this.sourceInput?.getAttribute('data-min') || this.data.min || 1);
      const step = Math.max(1, Number(this.sourceInput?.getAttribute('step') || this.data.step || 1));
      const maxAttr = this.sourceInput?.getAttribute('max') || this.sourceInput?.getAttribute('data-max') || this.data.max;
      const max = maxAttr == null || maxAttr === '' ? null : Number(maxAttr);
      return { min, increment: step, max };
    }

    syncFromSourceInput() {
      if (this.isSyncingSourceInput) return;

      this.refreshFormBindings();
      const quantity = this.normalizeQuantity(this.sourceInput?.value || this.data.defaultQuantity || this.data.min);
      const keepCustomSelection = this.compactGrid && this.selectionMode === 'custom' && this.state?.quantity === quantity;
      const hasQuantityButton = this.tierButtons.some((button) => Number(button.dataset.tierQty) === quantity);
      const selectionMode = keepCustomSelection || !hasQuantityButton ? 'custom' : 'tier';
      this.applyQuantity(quantity, {
        close: false,
        syncOnly: true,
        selectionMode,
        preserveCustomInput: keepCustomSelection && document.activeElement === this.customInput,
      });
    }

    normalizeQuantity(rawValue) {
      if (this.helper?.normalizeQuantity) {
        return this.helper.normalizeQuantity(rawValue, this.getRules(), 'up');
      }

      let quantity = Number.parseInt(rawValue, 10);
      const rules = this.getRules();
      if (!Number.isFinite(quantity) || quantity < rules.min) quantity = rules.min;
      return quantity;
    }

    computeState(quantity) {
      if (this.supplierPricing) return this.getSupplierPricingState(quantity);
      if (this.helper?.computeState) {
        const state = this.helper.computeState({
          quantity,
          tiers: this.data.tiers,
          rules: this.getRules(),
          quantityMode: 'up',
        });
        return state ? { ...state, sourceCurrency: this.getSourceCurrency(), pricingNative: this.data.pricingNative === true } : null;
      }

      const normalizedQuantity = this.normalizeQuantity(quantity);
      let appliedTier = this.data.tiers[0];

      this.data.tiers.forEach((tier) => {
        if (tier.qty <= normalizedQuantity) appliedTier = tier;
      });

      const baseTier = this.data.tiers[0];
      const discountPct =
        baseTier.unit_price_cents > appliedTier.unit_price_cents
          ? Math.round(((baseTier.unit_price_cents - appliedTier.unit_price_cents) / baseTier.unit_price_cents) * 100)
          : 0;

      return {
        quantity: normalizedQuantity,
        sourceCurrency: this.getSourceCurrency(),
        pricingNative: this.data.pricingNative === true,
        appliedTierQty: appliedTier.qty,
        unitPriceCents: appliedTier.unit_price_cents,
        totalCents: normalizedQuantity * appliedTier.unit_price_cents,
        discountPct,
        pricingMode: normalizedQuantity === appliedTier.qty ? 'tier' : 'custom',
      };
    }

    applyQuantity(quantity, { close = false, syncOnly = false, selectionMode, preserveCustomInput = false, sourceEvent = null } = {}) {
      const state = this.computeState(quantity);
      if (!state) return;

      this.state = state;
      if (this.compactGrid) this.selectionMode = selectionMode || this.selectionMode || state.pricingMode;
      this.renderState(state, { preserveCustomInput });
      // Native input/change still reach the theme, but pricing can wait for
      // our single committed event instead of rescanning Studio three times.
      const previousCommit = this.committingQuantity;
      this.committingQuantity = !syncOnly || previousCommit;
      try { this.syncSourceInput(state.quantity); }
      finally { this.committingQuantity = previousCommit; }
      // A source-input listener may synchronously calculate the new public
      // tariff. Do not overwrite that result with the state read before it.
      const committedState = this.supplierPricing ? this.computeState(state.quantity) : state;
      this.state = committedState;
      this.syncPropertyInputs(committedState);

      if (close) this.drawer?.setOpen(false);
      if (!syncOnly) {
        const root = this.closest('product-info');
        if (root) root.todayMerchQuantitySelection = { productFormId: this.data.productFormId,
          quantity: state.quantity, selectionMode: this.selectionMode };
        const event = new CustomEvent('quantity-pricing:change', { bubbles: true, detail: committedState });
        if (sourceEvent) {
          sourceEvent.todayMerchQuantityHandled = this;
          event.todayMerchSourceEventType = sourceEvent.type;
          event.todayMerchQuantityCommit = sourceEvent.todayMerchQuantityCommit === true;
        }
        this.dispatchEvent(event);
      }
    }

    preparePersonalizationResumeQuantity(quantity) {
      const next = this.computeState(quantity), root = this.closest('product-info');
      if (!next || next.quantity !== quantity || !this.sourceInput) throw new Error('resume_quantity_unavailable');
      const before = { state: this.state, mode: this.selectionMode, value: this.sourceInput.value,
        attribute: this.sourceInput.getAttribute('value'), custom: this.customInput?.value, retained: root?.todayMerchQuantitySelection };
      let committed = false;
      return Object.freeze({
        commit: () => {
          if (committed) return false;
          committed = true;
          this.state = next; this.selectionMode = next.pricingMode;
          this.sourceInput.value = String(quantity); this.sourceInput.setAttribute('value', String(quantity));
          this.renderState(next); this.syncPropertyInputs(next);
          if (root) root.todayMerchQuantitySelection = { productFormId: this.data.productFormId, quantity, selectionMode: this.selectionMode };
          return true;
        },
        rollback: () => {
          if (!committed) return;
          this.state = before.state; this.selectionMode = before.mode; this.sourceInput.value = before.value;
          if (before.attribute === null) this.sourceInput.removeAttribute('value'); else this.sourceInput.setAttribute('value', before.attribute);
          if (this.customInput) this.customInput.value = before.custom;
          if (root) root.todayMerchQuantitySelection = before.retained;
          committed = false;
          if (before.state) { this.renderState(before.state, { preserveCustomInput: true }); this.syncPropertyInputs(before.state); }
        },
        publish: () => { if (committed) this.dispatchEvent(new CustomEvent('quantity-pricing:change', { bubbles: true, detail: this.state })); },
        dispose() {},
      });
    }

    renderState(state, { preserveCustomInput = false } = {}) {
      if (!state) return;

      setText(this.summaryQty, state.quantity);
      const supplierUnpriced = this.supplierPricing && state.supplierStatus !== 'priced';

      if (this.summaryUnitPrice && !supplierUnpriced) {
        setText(this.summaryUnitPrice, this.interpolateString(
          this.data.strings.eachPrice,
          this.formatMoney(state.unitPriceCents),
          'money'
        ));
      }

      if (this.summarySavings) {
        setText(this.summarySavings, this.interpolateString(this.data.strings.save, state.discountPct, 'percentage'));
        this.summarySavings.classList.toggle('is-muted', state.discountPct === 0);
      }

      if (this.summaryTotal && !supplierUnpriced) {
        setText(this.summaryTotal, this.formatMoney(state.feeMode === 'separate' ? state.totalPriceCents : state.totalCents, state.quantity));
      }

      if (this.compactGrid) {
        const customSelected = this.selectionMode === 'custom';
        this.customCell?.classList.toggle('is-active', customSelected);
        setAttribute(this.customCell, 'data-selected', String(customSelected));
        if (!preserveCustomInput) setValue(this.customInput, customSelected ? state.quantity : '');
        if (!supplierUnpriced) setText(this.customUnitPrice, this.quoteTiers ? '' : customSelected ? this.formatMoney(state.unitPriceCents) : '—');
      } else if (this.customInput && document.activeElement !== this.customInput) {
        setValue(this.customInput, state.quantity);
      }

      this.tierButtons.forEach((button) => {
        const isActive = this.compactGrid
          ? this.selectionMode !== 'custom' && Number.parseInt(button.dataset.tierQty, 10) === state.quantity
          : Number.parseInt(button.dataset.tierQty, 10) === state.appliedTierQty;
        button.classList.toggle('is-active', isActive);
        setAttribute(button, 'aria-pressed', isActive ? 'true' : 'false');
      });
      if (this.supplierPricing) this.renderSupplierPricing(state);
    }

    // A supplier quote is valid only for the exact requested configuration and quantity.
    setSupplierPricing(value) {
      if (this.legacyXDPricingEnabled && value?.legacyPriceOnly !== true) return;
      if (this.configuredXDPricing && value?.legacyPriceOnly === true) return;
      if (value && !this.supplierPricing && !this.supplierOriginalTiers) {
        this.supplierOriginalTiers = this.tierButtons.map((button) => ({ button, html: button.innerHTML, price: button.dataset.tierUnitPriceCents }));
        this.supplierOriginalSavingsHidden = this.summarySavings?.hidden;
      }
      if (!value && this.supplierOriginalTiers) {
        this.supplierOriginalTiers.forEach(({ button, html, price }) => {
          button.innerHTML = html;
          if (price !== undefined) button.dataset.tierUnitPriceCents = price;
          else delete button.dataset.tierUnitPriceCents;
        });
        if (this.summarySavings) this.summarySavings.hidden = this.supplierOriginalSavingsHidden;
        this.supplierOriginalTiers = undefined;
        delete this.dataset.supplierPricingStatus;
      }
      if (!value) {
        for (const key of ['_xd_pricing', '_xd_quote_quantity', '_xd_quote_valid_until', '_xd_estimated', '_xd_estimate_quantity', '_xd_estimate_valid_until', '_xd_price_revision', '_personalization_pricing', '_personalization_quote_only', '_personalization_quote_quantity', '_personalization_quote_valid_until', '_personalization_price_revision', '_personalization_configuration', '_fee_mode', '_items_total_price_cents', '_technical_fees_cents', '_preparation_fees_cents', '_preparation_unit_price_micro', '_total_price_cents']) {
          this.form?.querySelector(`[data-supplier-property="${key}"]`)?.remove();
        }
      }
      this.supplierPricing = value;
      const quantity = this.sourceInput?.value || this.state?.quantity || this.data.defaultQuantity;
      this.applyQuantity(quantity, { syncOnly: true,
        preserveCustomInput: this.compactGrid && this.selectionMode === 'custom' && document.activeElement === this.customInput });
      this.dispatchEvent(new CustomEvent('supplier-pricing:change', { bubbles: true }));
    }

    getSupplierPricingState(quantity) {
      if (!this.supplierPricing) return null;
      const normalizedQuantity = this.normalizeQuantity(quantity);
      const supplier = this.supplierPricing;
      const quote = supplier.quote, amounts = quoteAmounts(quote, normalizedQuantity);
      const priced = supplier.status === 'priced' && quote?.quantity === normalizedQuantity
        && (!(this.legacyXDPricingEnabled || this.configuredXDPricing) || (supplier.variantId || quote.variantId) === String(this.form?.querySelector('input[name="id"]')?.value || ''))
        && (!this.configuredXDPricing || supplier.configurationRevision === this.configuredXDPricing.configurationRevision)
        && Number.isSafeInteger(quote.unitPriceCents) && quote.unitPriceCents > 0
        && amounts !== null
        && Date.parse(supplier.validUntil) > Date.now();
      const pending = supplier.status === 'pending' || supplier.status === 'priced'
        && quote?.quantity !== normalizedQuantity && Date.parse(supplier.validUntil) > Date.now();
      const unavailable = supplier.status === 'unavailable';
      return {
        quantity: normalizedQuantity, sourceCurrency: 'EUR', pricingNative: false,
        appliedTierQty: priced ? normalizedQuantity : '', unitPriceCents: priced ? quote.unitPriceCents : null,
        ...(priced && amounts.feeMode ? amounts : {}),
        totalCents: priced ? amounts.itemsTotalPriceCents : null, discountPct: 0,
        pricingMode: priced ? (supplier.provider === 'personalization' ? 'personalization_quote' : supplier.estimated === true ? 'supplier_estimate' : 'supplier_quote') : 'quote_required', supplierStatus: priced ? 'priced' : pending ? 'pending' : unavailable ? 'unavailable' : 'quote_required',
      };
    }

    renderSupplierPricing(state) {
      const priced = state.supplierStatus === 'priced';
      const unavailable = this.supplierPricing.status === 'unavailable';
      const pending = state.supplierStatus === 'pending';
      const label = pending ? 'Calcul…' : unavailable ? 'Indisponible' : 'À confirmer';
      setAttribute(this, 'aria-busy', pending ? 'true' : 'false');
      if (this.summarySavings) this.summarySavings.hidden = true;
      if (!priced) {
        setText(this.summaryUnitPrice, label);
        setText(this.summaryTotal, label);
        setText(this.customUnitPrice, label);
      }
      const grid = Date.parse(this.supplierPricing.validUntil) > Date.now() ? this.supplierPricing.grid || [] : [];
      this.tierButtons.forEach((button) => {
        const quantity = Number(button.dataset.tierQty);
        const tier = grid.find((entry) => entry.quantity === quantity && entry.status === 'priced'
          && Number.isSafeInteger(entry.unitPriceCents) && entry.unitPriceCents > 0);
        this.supplierTierNodes ||= new WeakMap();
        let nodes = this.supplierTierNodes.get(button);
        if (!nodes || !nodes.unit || !nodes.total || Object.values(nodes).some(node => node && !button.contains(node))) {
          nodes = { unit: button.querySelector('.quantity-pricing-selector__tier-unit-price'),
            total: button.querySelector('.quantity-pricing-selector__tier-total'), savings: button.querySelector('.quantity-pricing-selector__tier-savings') };
          this.supplierTierNodes.set(button, nodes);
        }
        if (!nodes.savings) nodes.savings = button.querySelector('.quantity-pricing-selector__tier-savings');
        const { unit, total, savings } = nodes;
        if (tier) setAttribute(button, 'data-tier-unit-price-cents', String(tier.unitPriceCents));
        else if (button.hasAttribute('data-tier-unit-price-cents')) button.removeAttribute('data-tier-unit-price-cents');
        setText(unit, tier ? this.formatMoney(tier.unitPriceCents) : label);
        const completeFeesRequired = this.supplierPricing.quote?.feeMode === 'separate';
        const tierTotal = tier?.feeMode === 'separate' ? quoteAmounts(tier, quantity)?.totalPriceCents
          : completeFeesRequired ? null : tier?.unitPriceCents * quantity;
        setText(total, Number.isSafeInteger(tierTotal) ? this.formatMoney(tierTotal, quantity) : tier ? 'À confirmer' : label);
        if (savings) savings.hidden = true;
      });
      setAttribute(this, 'data-supplier-pricing-status', state.supplierStatus);
    }

    syncSourceInput(quantity) {
      this.refreshFormBindings();
      if (!this.sourceInput) return;

      const nextValue = String(quantity);
      if (this.sourceInput.value === nextValue) return;

      this.isSyncingSourceInput = true;

      try {
        this.sourceInput.value = nextValue;
        this.sourceInput.setAttribute('value', nextValue);
        this.sourceInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
      } finally {
        this.isSyncingSourceInput = false;
      }
    }

    syncPropertyInputs(state) {
      this.refreshFormBindings();
      if (this.supplierPricing) {
        const priced = state.supplierStatus === 'priced';
        const supplierProperties = this.supplierPricing.provider === 'embedded-display' ? {} : this.supplierPricing.provider === 'personalization' ? {
          _personalization_pricing: '1',
          _personalization_quote_only: '1',
          _personalization_quote_quantity: priced ? String(state.quantity) : '',
          _personalization_quote_valid_until: priced ? this.supplierPricing.validUntil : '',
          _personalization_price_revision: priced ? this.supplierPricing.revision : '',
          _personalization_configuration: priced ? this.supplierPricing.configurationKey : '',
        } : {
          _xd_pricing: '1',
          _xd_quote_quantity: priced && this.supplierPricing.estimated !== true ? String(state.quantity) : '',
          _xd_quote_valid_until: priced && this.supplierPricing.estimated !== true ? this.supplierPricing.validUntil : '',
          _xd_estimated: priced && this.supplierPricing.estimated === true ? '1' : '',
          _xd_estimate_quantity: priced && this.supplierPricing.estimated === true ? String(state.quantity) : '',
          _xd_estimate_valid_until: priced && this.supplierPricing.estimated === true ? this.supplierPricing.validUntil : '',
          _xd_price_revision: priced && this.supplierPricing.estimated === true ? this.supplierPricing.revision : '',
        };
        Object.assign(supplierProperties, {
          _fee_mode: priced && state.feeMode === 'separate' ? 'separate' : '',
          _items_total_price_cents: priced && state.feeMode === 'separate' ? String(state.itemsTotalPriceCents) : '',
          _technical_fees_cents: priced && state.feeMode === 'separate' ? String(state.technicalFeesCents) : '',
          _preparation_fees_cents: priced && state.feeMode === 'separate' ? String(state.preparationFeesCents) : '',
          _preparation_unit_price_micro: priced && state.feeMode === 'separate' ? state.preparationUnitPriceMicro || '' : '',
          _total_price_cents: priced && state.feeMode === 'separate' ? String(state.totalPriceCents) : '',
        });
        if (this.legacyXDPricingEnabled) Object.assign(supplierProperties, {
          _xd_legacy_price_only: '1', _xd_legacy_configuration_revision: this.legacyXDScope.revision,
          _xd_legacy_variant_id: priced ? this.supplierPricing.quote?.variantId || '' : '',
          _xd_requires_size_allocation: String(this.legacyXDScope.sizes),
        });
        if (this.configuredXDPricing) {
          const context = this.getConfiguredXDPricingContext();
          Object.assign(supplierProperties, {
            _xd_configuration_revision: context?.configurationRevision || '',
            _xd_requires_size_allocation: String(context?.requiresSizeAllocation === true),
            _xd_size_options: context?.requiresSizeAllocation ? JSON.stringify(context.sizeOptions) : '',
          });
        }
        Object.entries(supplierProperties).forEach(([key, value]) => {
          if (!this.form) return;
          this.supplierPropertyInputs ||= new Map();
          let input = this.supplierPropertyInputs.get(key);
          if (!input?.isConnected || !this.form.contains(input)) input = this.form.querySelector(`[data-supplier-property="${key}"]`);
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${key}]`;
            input.dataset.supplierProperty = key;
            this.form.append(input);
          }
          this.supplierPropertyInputs.set(key, input);
          setValue(input, value ?? '');
        });
        for (const key of ['appliedDiscountPct', 'profile', 'tiers']) setValue(this.properties[key], '');
        setValue(this.properties.appliedTierQty, priced ? state.quantity : '');
        setValue(this.properties.appliedUnitPriceCents, priced ? state.unitPriceCents : '');
        setValue(this.properties.pricingMode, state.pricingMode);
        setValue(this.properties.currency, 'EUR');
        setValue(this.properties.native, 'false');
        return;
      }
      const serializedTiers = this.helper?.serializeTiers ? this.helper.serializeTiers(this.data.tiers) : JSON.stringify(this.data.tiers);

      if (this.properties.appliedTierQty) this.properties.appliedTierQty.value = state.appliedTierQty;
      if (this.properties.appliedUnitPriceCents) this.properties.appliedUnitPriceCents.value = state.unitPriceCents;
      if (this.properties.appliedDiscountPct) this.properties.appliedDiscountPct.value = state.discountPct;
      if (this.properties.pricingMode) this.properties.pricingMode.value = state.pricingMode;
      if (this.properties.profile) this.properties.profile.value = this.data.profileLabel || '';
      if (this.properties.tiers) this.properties.tiers.value = serializedTiers;
      if (this.properties.currency) this.properties.currency.value = this.getSourceCurrency();
      if (this.properties.native) this.properties.native.value = String(this.data.pricingNative === true);
    }

    getSourceCurrency() {
      if (this.supplierPricing) return 'EUR';
      return this.data?.sourceCurrency || window.TodayMerchMoney?.baseCurrency() || 'EUR';
    }

    formatMoney(cents, quantity) {
      const sourceCurrency = this.getSourceCurrency();
      if (this.helper?.formatMoney) {
        return this.helper.formatMoney(cents, window.FoxTheme?.settings?.moneyFormat, sourceCurrency, quantity);
      }
      if (window.TodayMerchMoney?.format) {
        return window.TodayMerchMoney.format(cents, { sourceCurrency, quantity });
      }
      const locale = document.documentElement.lang || 'fr', key = `${locale}:${sourceCurrency}`;
      if (this.moneyFormatterKey !== key) {
        this.moneyFormatterKey = key;
        this.moneyFormatter = new Intl.NumberFormat(locale, { style: 'currency', currency: sourceCurrency });
      }
      return this.moneyFormatter.format(cents / 100);
    }

    interpolateString(template, replacement, token) {
      return String(template || '')
        .replace(`[${token}]`, replacement)
        .replace(`{{ ${token} }}`, replacement)
        .replace(`{{${token}}}`, replacement);
    }
  }

  customElements.define('product-quantity-pricing-selector', ProductQuantityPricingSelector);
}
